import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

const EventByThemeWidget = () => {
  const navigate = useNavigate();

  const dictionary = useSelector((state) => state.dictionaryReducer.dictionary);

  const thing = () => {
    const thingSelectAll = document.querySelectorAll('.thing-select');

    thingSelectAll.forEach((thingSelect) => {
      thingSelect.addEventListener('click', (e) => {
        const container = thingSelect.querySelector('.thing-select__container');
        const box = thingSelect.querySelector('.thing-select__box');
        let { target } = e;

        if (target.closest('.thing-select__head')) {
          target = target.closest('.thing-select__head');
          if (!target.classList.contains('show')) {
            thingSelectAll.forEach((elem) => {
              const containerElem = elem.querySelector(
                '.thing-select__container',
              );
              const titleElem = elem.querySelector('.thing-select__head');
              titleElem.classList.remove('show');
              containerElem.removeAttribute('style');
            });
            target.classList.add('show');
            container.style.cssText = `
              height: ${box.clientHeight}px;
            `;
          } else {
            target.classList.remove('show');
            container.removeAttribute('style');
          }
        }
      });
    });
  };

  useEffect(() => {
    thing();
  }, []);

  return (
    <div className="thing">
      <div className="thing-title">
        <span>{dictionary.event_by_theme}</span>
      </div>

      <div className="thing-select">
        <div className="thing-select__head">
          <span className="thing-select__title">
            {dictionary.internal_politics}
          </span>
          <div className="thing-select__arrow">
            <svg
              width="14"
              height="8"
              viewBox="0 0 14 8"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M1.54295 1.25316L7.05199 6.76221L12.561 1.25316"
                stroke="#333333"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>
        </div>
        <div className="thing-select__container">
          <div className="thing-select__box">
            <a
              onClick={(e) => {
                e.preventDefault();
                navigate('/event_by_theme/internal_politics/independence');
              }}
              href="/event_by_theme/internal_politics/independence"
              className="thing-select__item"
            >
              <span>{dictionary.independence}</span>
            </a>
            <a
              onClick={(e) => {
                e.preventDefault();
                navigate('/event_by_theme/internal_politics/constitution');
              }}
              href="/event_by_theme/internal_politics/constitution"
              className="thing-select__item"
            >
              <span>{dictionary.constitution}</span>
            </a>
            <a
              onClick={(e) => {
                e.preventDefault();
                navigate('/event_by_theme/internal_politics/oath');
              }}
              href="/event_by_theme/internal_politics/oath"
              className="thing-select__item"
            >
              <span>{dictionary.oath}</span>
            </a>
            <a
              onClick={(e) => {
                e.preventDefault();
                navigate('/event_by_theme/internal_politics/national_unity');
              }}
              href="/event_by_theme/internal_politics/national_unity"
              className="thing-select__item"
            >
              <span>{dictionary.national_unity}</span>
            </a>
            <a
              onClick={(e) => {
                e.preventDefault();
                navigate(
                  '/event_by_theme/internal_politics/meetings_with_intelligentsia',
                );
              }}
              href="/event_by_theme/internal_politics/meetings_with_intelligentsia"
              className="thing-select__item"
            >
              <span>{dictionary.meetings_with_intelligentsia}</span>
            </a>
            <a
              onClick={(e) => {
                e.preventDefault();
                navigate('/event_by_theme/internal_politics/navruz');
              }}
              href="/event_by_theme/internal_politics/navruz"
              className="thing-select__item"
            >
              <span>{dictionary.navruz}</span>
            </a>
            <a
              onClick={(e) => {
                e.preventDefault();
                navigate('/event_by_theme/internal_politics/mothers_day');
              }}
              href="/event_by_theme/internal_politics/mothers_day"
              className="thing-select__item"
            >
              <span>{dictionary.mothers_day}</span>
            </a>
            <a
              onClick={(e) => {
                e.preventDefault();
                navigate('/event_by_theme/internal_politics/ramadan');
              }}
              href="/event_by_theme/internal_politics/ramadan"
              className="thing-select__item"
            >
              <span>{dictionary.ramadan}</span>
            </a>
            <div className="main-tab__button" style={{ marginTop: '1em' }}>
              <a
                onClick={(e) => {
                  e.preventDefault();
                  navigate('/event_by_theme/internal_politics');
                }}
                href="/event_by_theme/internal_politics"
                className="button button-update"
              >
                {dictionary.more}
              </a>
            </div>
          </div>
        </div>
      </div>

      <div className="thing-select">
        <div className="thing-select__head">
          <span className="thing-select__title">
            {dictionary.international_structures}
          </span>
          <div className="thing-select__arrow">
            <svg
              width="14"
              height="8"
              viewBox="0 0 14 8"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M1.54295 1.25316L7.05199 6.76221L12.561 1.25316"
                stroke="#333333"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>
        </div>
        <div className="thing-select__container">
          <div className="thing-select__box">
            <a
              onClick={(e) => {
                e.preventDefault();
                navigate('/event_by_theme/international_structures/un');
              }}
              href="/event_by_theme/international_structures/un"
              className="thing-select__item"
            >
              <span>{dictionary.un}</span>
            </a>
            <a
              onClick={(e) => {
                e.preventDefault();
                navigate('/event_by_theme/international_structures/sco');
              }}
              href="/event_by_theme/international_structures/sco"
              className="thing-select__item"
            >
              <span>{dictionary.sco}</span>
            </a>
            <a
              onClick={(e) => {
                e.preventDefault();
                navigate('/event_by_theme/international_structures/csto');
              }}
              href="/event_by_theme/international_structures/csto"
              className="thing-select__item"
            >
              <span>{dictionary.csto}</span>
            </a>
            <a
              onClick={(e) => {
                e.preventDefault();
                navigate('/event_by_theme/international_structures/cis');
              }}
              href="/event_by_theme/international_structures/cis"
              className="thing-select__item"
            >
              <span>{dictionary.cis}</span>
            </a>
            <a
              onClick={(e) => {
                e.preventDefault();
                navigate(
                  '/event_by_theme/international_structures/organisation_of_islamic_cooperation',
                );
              }}
              href="/event_by_theme/international_structures/organisation_of_islamic_cooperation"
              className="thing-select__item"
            >
              <span>{dictionary.organisation_of_islamic_cooperation}</span>
            </a>
            <a
              onClick={(e) => {
                e.preventDefault();
                navigate(
                  '/event_by_theme/international_structures/the_economic_cooperation_organization',
                );
              }}
              href="/event_by_theme/international_structures/the_economic_cooperation_organization"
              className="thing-select__item"
            >
              <span>{dictionary.the_economic_cooperation_organization}</span>
            </a>
            <a
              onClick={(e) => {
                e.preventDefault();
                navigate('/event_by_theme/international_structures/nato');
              }}
              href="/event_by_theme/international_structures/nato"
              className="thing-select__item"
            >
              <span>{dictionary.nato}</span>
            </a>
            <a
              onClick={(e) => {
                e.preventDefault();
                navigate('/event_by_theme/international_structures/osce');
              }}
              href="/event_by_theme/international_structures/osce"
              className="thing-select__item"
            >
              <span>{dictionary.osce}</span>
            </a>
            <div className="main-tab__button" style={{ marginTop: '1em' }}>
              <a
                onClick={(e) => {
                  e.preventDefault();
                  navigate('/event_by_theme/international_structures');
                }}
                href="/event_by_theme/international_structures"
                className="button button-update"
              >
                {dictionary.more}
              </a>
            </div>
          </div>
        </div>
      </div>

      <div className="thing-select">
        <div className="thing-select__head">
          <span className="thing-select__title">
            {dictionary.bilateral_relations}
          </span>
          <div className="thing-select__arrow">
            <svg
              width="14"
              height="8"
              viewBox="0 0 14 8"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M1.54295 1.25316L7.05199 6.76221L12.561 1.25316"
                stroke="#333333"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>
        </div>
        <div className="thing-select__container">
          <div className="thing-select__box">
            <a
              onClick={(e) => {
                e.preventDefault();
                navigate('/event_by_theme/bilateral_relations/russia');
              }}
              href="/event_by_theme/bilateral_relations/russia"
              className="thing-select__item"
            >
              <span>{dictionary.russia}</span>
            </a>
            <a
              onClick={(e) => {
                e.preventDefault();
                navigate('/event_by_theme/bilateral_relations/iran');
              }}
              href="/event_by_theme/bilateral_relations/iran"
              className="thing-select__item"
            >
              <span>{dictionary.iran}</span>
            </a>
            <a
              onClick={(e) => {
                e.preventDefault();
                navigate('/event_by_theme/bilateral_relations/china');
              }}
              href="/event_by_theme/bilateral_relations/china"
              className="thing-select__item"
            >
              <span>{dictionary.china}</span>
            </a>
            <a
              onClick={(e) => {
                e.preventDefault();
                navigate('/event_by_theme/bilateral_relations/ukraine');
              }}
              href="/event_by_theme/bilateral_relations/ukraine"
              className="thing-select__item"
            >
              <span>{dictionary.ukraine}</span>
            </a>
            <a
              onClick={(e) => {
                e.preventDefault();
                navigate('/event_by_theme/bilateral_relations/turkey');
              }}
              href="/event_by_theme/bilateral_relations/turkey"
              className="thing-select__item"
            >
              <span>{dictionary.turkey}</span>
            </a>
            <a
              onClick={(e) => {
                e.preventDefault();
                navigate('/event_by_theme/bilateral_relations/pakistan');
              }}
              href="/event_by_theme/bilateral_relations/pakistan"
              className="thing-select__item"
            >
              <span>{dictionary.pakistan}</span>
            </a>
            <a
              onClick={(e) => {
                e.preventDefault();
                navigate('/event_by_theme/bilateral_relations/kazahstan');
              }}
              href="/event_by_theme/bilateral_relations/kazahstan"
              className="thing-select__item"
            >
              <span>{dictionary.kazahstan}</span>
            </a>
            <a
              onClick={(e) => {
                e.preventDefault();
                navigate('/event_by_theme/bilateral_relations/mongolia');
              }}
              href="/event_by_theme/bilateral_relations/mongolia"
              className="thing-select__item"
            >
              <span>{dictionary.mongolia}</span>
            </a>
            <div className="main-tab__button" style={{ marginTop: '1em' }}>
              <a
                onClick={(e) => {
                  e.preventDefault();
                  navigate('/event_by_theme/bilateral_relations');
                }}
                href="/event_by_theme/bilateral_relations"
                className="button button-update"
              >
                {dictionary.more}
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EventByThemeWidget;
